/**
 * `request_id` arrives from the query string, so it is caller-controlled and must be encoded
 * before it becomes part of a path.
 *
 * Unencoded, a value like `../../users/x?a=` retargets both the authenticated GET and the
 * `{approved: true}` POST at an arbitrary API path. Reaching anything useful that way is
 * contrived -- the GET has to return `llmAccessEnabled` truthy before
 * the buttons render at all -- but that is an argument about exploitability, not about the code
 * being right.
 *
 * Encoded here rather than at the call site so there is one place to get it right, and no way to
 * build one of these keys without it.
 */
export const oauthQueryKeys = {
  consentDetails: (requestId: string) =>
    [`oauth2/authorize/${encodeURIComponent(requestId)}`, requestId] as const
}

export const oauthMutationKeys = {
  confirmConsent: (requestId: string) =>
    [
      `oauth2/authorize/${encodeURIComponent(requestId)}/confirm`,
      { method: 'post' }
    ] as const
}
